import React from 'react';
import { m } from 'framer-motion';
import { CreditCardIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { CHECKOUT_URL } from '../utils/checkout';
const rows = [{
  content: 'Colección Didáctica (6 Tomos)',
  value: '59,90€'
}, {
  content: 'Los 5 Bonos Estratégicos',
  value: '59,50€'
}];
const trustItems = [{
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}];
export function Pricing() {
  return <section id="oferta-base" className="bg-bg-primary py-10 sm:py-14" data-id="element-185" data-mp="3uikr6nee293c">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-186" data-mp="3ughtdh6zvbo2">
        <SectionTag icon="💰" data-id="element-187" data-mp="3b87a0m4fhjq">Oferta Especial</SectionTag>
        <h2 className="mt-4 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-188" data-mp="204jmhlw5qrvc">
          ¿Cuánto vale para ti recuperar tus domingos?
        </h2>
        <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-189" data-mp="255qtvjue1p1h">
          Acceso inmediato y garantía de 7 días.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md px-4 sm:px-6" data-id="element-190" data-mp="16ji44wauu9sv">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="rounded-3xl border border-orange/30 bg-bg-secondary p-6 sm:p-7" data-id="element-191" data-mp="16hx8128w6isw">
          <p className="font-heading text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-192" data-mp="1u8b0uuzawloj">
            🏀 El Manual del Entrenador de Baloncesto
          </p>
          <p className="mt-1.5 text-sm font-semibold text-white" data-id="element-193" data-mp="1l8ejlef8qp3i">
            6 tomos + 5 bonos + 6 cuadernos prácticos visuales
          </p>

          <ul className="mt-3 space-y-1.5" data-id="element-194" data-mp="1g9jslp74du8b">
            {['La colección original de seis tomos.', 'Los cinco bonos de apoyo.', '38 sesiones adicionales organizadas por edades y objetivos.', 'Ejercicios con mapas de cancha, tiempos y rotaciones.', '8 dinámicas de equipo y plantillas imprimibles.'].map(item => <li key={item} className="flex items-start gap-2 text-xs text-white/80" data-id="element-195" data-mp="ba52frum1xs4">
                <CheckIcon size={13} className="mt-0.5 flex-shrink-0 text-success" data-id="element-196" data-mp="3tfzww5nkzbad" />
                {item}
              </li>)}
          </ul>
          <p className="mt-2 text-xs italic text-muted" data-id="element-197" data-mp="3jqzv6ehp21sh">
            Los seis cuadernos complementarios están incluidos en el precio mostrado.
          </p>

          <div className="mt-4 space-y-1.5" data-id="element-198" data-mp="3oirec3yit58l">
            {rows.map(row => <div key={row.content} className="flex items-center justify-between gap-3 border-b border-white/5 py-1.5 text-sm" data-id="element-199" data-mp="39tv4c1cwli5c">
                <span className="text-white/80" data-id="element-200" data-mp="30rlyhoskycya">{row.content}</span>
                <span className="flex-shrink-0 text-muted line-through" data-id="element-201" data-mp="35qytwxxiosch">{row.value}</span>
              </div>)}
            <div className="flex items-center gap-2 py-1.5 text-sm text-white/80" data-id="element-202" data-mp="2m4nbc60ra4pd">
              <CheckIcon size={14} className="flex-shrink-0 text-success" data-id="element-203" data-mp="2h6bx7j3fh81c" />
              Acceso de por vida
            </div>
            <div className="flex items-center justify-between py-1.5 text-sm font-semibold text-white" data-id="element-204" data-mp="2v6whykswldxh">
              <span data-id="element-205" data-mp="2r36tdvc8awcg">VALOR TOTAL</span>
              <span data-id="element-206" data-mp="2r6cnjozpsof1">119,40€</span>
            </div>
          </div>

          <p className="mt-4 text-xs font-medium text-muted" data-id="element-207" data-mp="352q32skoufqv">Precio hoy (84% de descuento):</p>
          <p className="font-heading text-5xl font-bold text-orange sm:text-6xl" data-id="element-208" data-mp="303wlop2a64lf">19€</p>
          <p className="mt-2 text-sm text-danger" data-id="element-209" data-mp="3eu408tp633gu">⏰ Precio de lanzamiento — sube pronto</p>
          <p className="mt-1 text-xs text-muted" data-id="element-210" data-mp="39uhjwbe1l73t">
            Precio en euros. Se cobra en la moneda de tu país según el método de pago disponible en el
            checkout.
          </p>

          <div className="mt-6" data-id="element-211" data-mp="3ivxvunki9ha5">
            <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-2 rounded-xl bg-orange px-8 py-4 font-heading text-base font-semibold uppercase tracking-wide text-white transition-all duration-200 hover:bg-orange-hover active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-orange focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary sm:text-lg" data-id="element-212" data-mp="3iwqrase0kkcz">
              Quiero la colección completa
            </a>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-213" data-mp="y9gya3l5h5q8">
            {trustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-214" data-mp="177szezjn7lwx">
                <item.icon size={12} data-id="element-215" data-mp="1c6x8zrahblns" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}